import { render } from "./TheNoPicturesMessage.vue?vue&type=template&id=16b1083e"
const script = {}

import "./TheNoPicturesMessage.vue?vue&type=style&index=0&id=16b1083e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__